// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7484c0f3","946":"07becbed"}[chunkId] + ".chunk.js";
};